import { render, staticRenderFns } from "./PriceMonitor.vue?vue&type=template&id=3802a5d7&scoped=true"
import script from "./PriceMonitor.vue?vue&type=script&lang=js"
export * from "./PriceMonitor.vue?vue&type=script&lang=js"
import style0 from "./PriceMonitor.vue?vue&type=style&index=0&id=3802a5d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3802a5d7",
  null
  
)

export default component.exports